import Module from 'BootQuery/Assets/js/module';

export default class Voicemails extends Module {
	activateElements(target, data) {
		target.findElement('#use-mailbox').off('change').on('change', function(e) {
			e.preventDefault();
			getJSON('get', 'voicemails', 'setActiveMailbox', {'mailbox' : $(e.target).val()}, true, function(data) { console.log(data); });
		});
	}
}